
import wx from 'weixin-js-sdk';
import ConfirmPlugin from 'vux/src/plugins/confirm/index.js'

import Vue from 'vue';
import Tabbar from 'vux/src/components/tabbar/tabbar.vue'
import TabbarItem from 'vux/src/components/tabbar/tabbar-item.vue'
import Divider from 'vux/src/components/divider/index.vue'
import Grid from 'vux/src/components/grid/grid.vue'
import GridItem from 'vux/src/components/grid/grid-item.vue'
import Checklist from 'vux/src/components/checklist/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import Tab from 'vux/src/components/tab/tab.vue'
import CheckIcon from 'vux/src/components/check-icon/index.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'
import XDialog from 'vux/src/components/x-dialog/index.vue'
import XTable from 'vux/src/components/x-table/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import dateFormat from 'vux/src/tools/date/format.js'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'

import {fetch,promptMessage,baseUrl} from '@/api/dataHandling';
import {urlConfig} from '@/api/urlConfig';
import {getken} from '@/api/getToken';
import axios from 'axios';
Vue.use(ConfirmPlugin);

export default {

data () {
return {
headTitle:'',
tabTitle:['待预约项目','已预约项目'],
allChecked:false,
inputTxt:[],
resonList: [],
dialogshow:false,
bigTabIndex:0,
qdDisable:false,
oneces:false,
dateFormat,
allyyytableData:{
today:[],
other:[]
},
dyytableData:[],
yyytableData:[],
personInfoId:'',
pageTpe:'',

}
},
directives: {
TransferDom
},
components: {
Grid, GridItem,Checklist ,TabItem, Tab, XHeader,XTable,XButton,XDialog,CheckIcon,Divider,Tabbar, TabbarItem,
},
watch:{
},
methods:{
edit(item){
localStorage.setItem('reservationData',JSON.stringify(item));
this.$router.push({path:'reservationDetails',query:{personInfoId:this.personInfoId,openid:this.openid}});
},   //修改预约
reservationZYClick(){
let DYYzyChecknum = 0;
let cheackData = [];
for(let i=0;i<this.dyytableData.length;i++){
if(this.dyytableData[i].checked){
DYYzyChecknum++;
cheackData.push(this.dyytableData[i]);
}
}
if(DYYzyChecknum>0){
localStorage.setItem('project',JSON.stringify(cheackData));
this.$router.push({path:'/reservationChineseMedical',query:{openid:this.openid,personInfoId:this.personInfoId}});

}else{
promptMessage('提示','请勾选您要预约的项目！')
}
},
allCheckedChoose(){
if(this.pageTpe == 'zy'){
if(this.allChecked){
for(let i=0;i<this.dyytableData.length;i++){
this.dyytableData[i].checked = true;
}
}else{
for(let i=0;i<this.dyytableData.length;i++){
this.dyytableData[i].checked = false;
}
}
}

},
reservation(obj){
fetch('get',urlConfig.reservationNotBtn + '?personInfoId=' + this.personInfoId).then(response => {
obj.personInfoId = this.personInfoId;
obj.openid = this.openid;
if(response.canOrders){

localStorage.setItem('reservationData',JSON.stringify(obj))
if(obj.orderClass == '10001'){
this.$router.push({path:'/reservationDoctor',query:obj});
}else {
this.$router.push({path:'/reservationDetails',query:{personInfoId:this.personInfoId,openid:this.openid}});
}

}else {
promptMessage('提示',response.resultMsg);
}

}).catch(error => {
})
},
cancelSS(){
if(this.inputTxt.length !=0){  //取消预约
this.dialogshow = false;
this.parmaData = new URLSearchParams();
this.parmaData.append('id',this.itemID);
this.parmaData.append('cancelReasonDm',this.inputTxt.toString());
fetch('post',urlConfig.surgicalAppointCancel,this.parmaData).then(response => {
promptMessage('提示','取消成功！');
this.inputTxt = [];
this.gettableData();

}).catch(error => {

})
}else{
this.$vux.toast.show({
type:'text',
text: '请选择取消原因'
});
}
},  // 取消手术预约
cancelReservation(item){
if(this.pageTpe == 'ss'){
this.itemID = item.id;
this.dialogshow = true;
}else{
this.otherappointmentCancel(item);
}

},  // 取消预约
otherappointmentCancel(obj){

const _this = this
this.$vux.confirm.show({
title: '提示',
content: '取消当前预约？',
cancelText:'不，再考虑一下',
onConfirm () {
_this.parmdata = new URLSearchParams();
_this.parmdata.append('orderId',obj.orderId);
_this.parmdata.append('bsuperOrderID',obj.bsuperOrderID);
_this.parmdata.append('personInfoId',_this.personInfoId);
_this.parmdata.append('orderClass',obj.orderClass);
_this.parmdata.append('orderDate',obj.orderDate);
_this.parmdata.append('shiftTime',obj.shiftTime);
_this.parmdata.append('doctorId',null);
_this.parmdata.append('doctorName',null);

fetch('post',urlConfig.reservationCancel,_this.parmdata).then(response => {
promptMessage('提示','取消成功！');
_this.bigTabIndex = 0
_this.gettableData();
}).catch(error => {

})
}  //确认
})
}, //取消其他预约
HeaderswitchTab(index){
this.bigTabIndex = index;
this.gettableData();
},
register(location,item,time){

this.$store.commit('updateLoadingStatus',{isLoading:true});
if(new Date().getFullYear() == new Date(time).getFullYear() && new Date().getMonth() == new Date(time).getMonth() && new Date().getDate() == new Date(time).getDate()){
this.getweixinDate(location,item);

}else {
promptMessage('提示','必须在预约日期：'+ time +' 当天签到！');
this.$store.commit('updateLoadingStatus',{isLoading:false});
}

},//签到
getUserId(){

this.$store.commit('updateLoadingStatus',{isLoading:true});
fetch('get',urlConfig.GetSfzh + '?openid='+this.openid).then(response => {
this.getPersonInfoId(response.sfzh);
}).catch(error => {

})
},
getPersonInfoId(sfzh){
let _this =this;
fetch('get',urlConfig.GetPersonInfoId + '?sfzh='+sfzh).then(response => {
this.personInfoId = response.personInfoId;
if(this.$route.query.tabindex){

this.$nextTick(function(){
_this.bigTabIndex = Number(this.$route.query.tabindex);
_this.gettableData();
});
}else if(this.pageTpe){
this.$nextTick(function(){
_this.bigTabIndex = 1;
_this.gettableData();
});
}else{
this.headTitle = '全部已预约';
this.getallyyydata();
}
/*       if(this.$route.query.tabindex || this.pageTpe){

this.$nextTick(function(){
_this.bigTabIndex = 1;
_this.gettableData();
});
}else{
this.headTitle = '全部已预约';
this.getallyyydata();
}*/

fetch('post',urlConfig.patientBasicInfosGet + '?personInfoId=' +response.personInfoId).then(res => { //获取患者信息

localStorage.setItem('patientBasic',JSON.stringify(res));
}).catch(error => {
})
this.$store.commit('updateLoadingStatus',{isLoading:false});
this.$store.commit('updateLoadingStatus',{isLoading:false});
}).catch(error => {

})

},
gettableData(){
let gettableurl = '';
let dataoBJ = '';

if(this.pageTpe == 'zs'){  //注射
this.headTitle = '注射预约';
if(this.bigTabIndex == 0){
this.dyytableData =[];
}else{
this.$store.commit('updateLoadingStatus',{isLoading:true});
this.yyytableData =[];
fetch('post',urlConfig.reservationJCYYYData+this.personInfoId+'&scheduleBigClass=02').then(response => {
this.yyytableData = response;
this.$store.commit('updateLoadingStatus',{isLoading:false});
}).catch(error => {

})
}

}else if(this.pageTpe == 'jc'){  //检查检验
this.headTitle = 'B超/抽血预约';
if(this.bigTabIndex == 0){

this.$store.commit('updateLoadingStatus',{isLoading:true});
gettableurl = urlConfig.reservationJCWYYData+this.personInfoId;
dataoBJ = 'dyytableData';
}else{

this.$store.commit('updateLoadingStatus',{isLoading:true});
gettableurl = urlConfig.reservationJCYYYData+this.personInfoId+'&scheduleBigClass=01';
dataoBJ = 'yyytableData';
}
this[dataoBJ] =[];
fetch('post',gettableurl).then(response => {
this[dataoBJ] = response;
this.$store.commit('updateLoadingStatus',{isLoading:false});
}).catch(error => {

})
}else if(this.pageTpe == 'qt'){  //其他
this.headTitle = '其他预约';
if(this.bigTabIndex == 0){
this.dyytableData =[];
}else{

this.$store.commit('updateLoadingStatus',{isLoading:true});
this.yyytableData =[];
fetch('post', urlConfig.reservationJCYYYData+this.personInfoId+'&scheduleBigClass=04').then(response => {
this.yyytableData = response;
this.$store.commit('updateLoadingStatus',{isLoading:false});
}).catch(error => {

})
}
}else if(this.pageTpe == 'zy'){  //中医
this.headTitle = '中医预约';
if(this.bigTabIndex == 0){
this.dyytableData =[];

this.$store.commit('updateLoadingStatus',{isLoading:true});
axios.defaults.headers.common['Authorization'] = window.localStorage.getItem('token');
axios.post( baseUrl + urlConfig.reservationZZsearch + '?personInfoId=' + this.personInfoId +'&isVip=2').then(response => {
this.dyytableData = response.data;
this.$store.commit('updateLoadingStatus',{isLoading:false});
}).catch(function (error) {
promptMessage('提示: ' +error);

});
}else{
this.$store.commit('updateLoadingStatus',{isLoading:true});
this.yyytableData =[];
fetch('post',urlConfig.reservationJCYYYData+this.personInfoId+'&scheduleBigClass=03').then(response => {
this.yyytableData = response;
this.$store.commit('updateLoadingStatus',{isLoading:false});
}).catch(error => {

})
}

}else if(this.pageTpe == 'all'){
this.headTitle = '全部已预约';
this.$store.commit('updateLoadingStatus',{isLoading:true});
this.getallyyydata();


}
this.contentHeight();
}, //获取预约信息
getallyyydata(){
this.$store.commit('updateLoadingStatus',{isLoading:true});
this.allyyytableData = {
today:[],
other:[]
};
fetch('post',urlConfig.reservationJCYYYData+this.personInfoId+'&scheduleBigClass=').then(response => {
console.log(response,444,dateFormat(new Date(), 'YYYY-MM-DD'))
let today = dateFormat(new Date(), 'YYYY-MM-DD');
for(let i=0;i<response.length;i++){
if(response[i].orderDate == today){
this.allyyytableData.today.push(response[i]);
}else{
this.allyyytableData.other.push(response[i]);
}
}

this.$store.commit('updateLoadingStatus',{isLoading:false});
}).catch(error => {

})
},
contentHeight(){
if((this.pageTpe == 'qt' || this.pageTpe == 'zs') && this.bigTabIndex == 0){

$('.content').css({height:window.innerHeight-92-62-50+'px'});

}else if(this.pageTpe == 'all'){

$('.allcontent').css({height:window.innerHeight-46-60-10+'px'});

}else{
$('.content').css({height:window.innerHeight-92-60-10+'px'});
}



},
getweixinDate(locations,item){
var locations = locations.split(',');
var _this = this;
axios.get('http://front.wh.jinxin-fertility.com/weixin/getsigninfo?url=' + encodeURIComponent(location.href.split('#')[0])+'&openid='+this.openid
).then(response => {
_this.weixindata = response.data;
console.log(_this.weixindata,3)
wx.config({
debug: false,
appId: _this.weixindata.appId,
timestamp: _this.weixindata.timestamp,
nonceStr: _this.weixindata.noncestr,
signature: _this.weixindata.signature,
jsApiList: ['checkJsApi', 'openLocation', 'getLocation']
});
}).catch(function (error) {
promptMessage('获取appid失败: ' +error);

})
_this.parmdata = new URLSearchParams();
_this.parmdata.append('orderId',item.orderId)
_this.parmdata.append('orderDate',item.orderDate)
_this.parmdata.append('shiftTime',item.shiftTime)
_this.parmdata.append('schedulingDId',item.schedulingDId)
_this.parmdata.append('timeItemId',item.timeItemId)
_this.parmdata.append('queuedm',item.queuedm)
_this.parmdata.append('personInfoId',_this.personInfoId)
_this.parmdata.append('areaId',item.areaId)

wx.ready(function () {
wx.checkJsApi({

jsApiList: ['getLocation'], // 需要检测的JS接口列表，所有JS接口列表见附录2,
success: function(res) {
},
fail:function (erorr) {
console.log(erorr,'检查')
},
});
wx.getLocation({
type:'wgs84',
fail:function (erorr) {
promptMessage('提示','签到失败，请检查是否打开微信定位权限，关闭当前页面重试');
},
success:function(res){
console.log('获取地理成功',res)
var latitude = res.latitude; 
var longitude = res.longitude; 
function toRad(d) {  return d * Math.PI / 180; }
function getDisance(lat1, lng1, lat2, lng2) {//lat为纬度, lng为经度, 一定不要弄错
var dis = 0;
var radLat1 = toRad(lat1);
var radLat2 = toRad(lat2);
var deltaLat = radLat1 - radLat2;
var deltaLng = toRad(lng1) - toRad(lng2);
var dis = 2 * Math.asin(Math.sqrt(Math.pow(Math.sin(deltaLat / 2), 2) + Math.cos(radLat1) * Math.cos(radLat2) * Math.pow(Math.sin(deltaLng / 2), 2)));
return parseInt(dis * 6378137);
}

_this.Distancetest = getDisance(latitude,longitude,locations[0],locations[1]);

if(_this.Distancetest <2500){

fetch('post',urlConfig.reservationSign,_this.parmdata).then(response => {
promptMessage('提示',response);
_this.qdDisable = false;
_this.gettableData();

}).catch(error => {
_this.qdDisable = false;
_this.$store.commit('updateLoadingStatus',{isLoading:false});
})
/* _this.gettableData();   //各刷新列表*/
}else {
promptMessage('提示','距离太远，请到院后签到！');
_this.qdDisable = false;
_this.$store.commit('updateLoadingStatus',{isLoading:false});
}

}
});


});

},
cancelReason(){
this.resonList = [];
fetch('get',urlConfig.surgicalAppointGetCancelReson).then(response => {
for(let i =0;i<response.length;i++){
this.resonList.push({value:response[i].szdCmc,key:response[i].szdDm});
}

}).catch(error => {
});
},
versions(){
var equipmentType = "";
var agent = navigator.userAgent.toLowerCase();
var android = agent.indexOf("android");
var iphone = agent.indexOf("iphone");
var ipad = agent.indexOf("ipad");
if(android != -1){
equipmentType = "android";
}
if(iphone != -1 || ipad != -1){
equipmentType = "ios";
}
return equipmentType;
},
menuClick(type){
this.pageTpe = type;
this.oneces = false;
if(this.pageTpe == 'zs'){  //注射
this.headTitle = '注射预约';
this.$store.commit('updateLoadingStatus',{isLoading:true});
this.yyytableData =[];
this.dyytableData =[];
fetch('post',urlConfig.reservationJCYYYData+this.personInfoId+'&scheduleBigClass=02').then(response => {
this.yyytableData = response;
if(response.length== 0){
this.bigTabIndex = 0;
}
this.$store.commit('updateLoadingStatus',{isLoading:false});
}).catch(error => {

})

}else if(this.pageTpe == 'jc'){  //检查检验
this.bigTabIndex = 0;
this.$store.commit('updateLoadingStatus',{isLoading:true});
this.headTitle = 'B超/抽血预约';
this.dyytableData =[];
this.yyytableData =[];
fetch('post',urlConfig.reservationJCWYYData+this.personInfoId).then(response => {
this.dyytableData = response;
if(response.length== 0){
fetch('post',urlConfig.reservationJCYYYData+this.personInfoId+'&scheduleBigClass=01').then(res => {   //已预约
this.yyytableData = res;
if(res.length == 0){
this.bigTabIndex = 0;
}else{
this.bigTabIndex = 1;
}
this.$store.commit('updateLoadingStatus',{isLoading:false});
}).catch(error => {

})
}else{
this.$store.commit('updateLoadingStatus',{isLoading:false});
}
}).catch(error => {

})  //未预约
}else if(this.pageTpe == 'qt'){  //其他
this.headTitle = '其他预约';
this.dyytableData =[];
this.$store.commit('updateLoadingStatus',{isLoading:true});
this.yyytableData =[];
fetch('post', urlConfig.reservationJCYYYData+this.personInfoId+'&scheduleBigClass=04').then(response => {
this.yyytableData = response;
if(response.length == 0){
this.bigTabIndex = 0;
}else{
this.bigTabIndex = 1;
}
this.$store.commit('updateLoadingStatus',{isLoading:false});
}).catch(error => {

})
}else if(this.pageTpe == 'all'){
this.headTitle = '全部已预约';
this.getallyyydata();
}else if(this.pageTpe == 'zy'){  //中医
this.headTitle = '中医预约';
this.$store.commit('updateLoadingStatus',{isLoading:true});
this.bigTabIndex = 0;
this.dyytableData =[];
this.yyytableData = [];
axios.defaults.headers.common['Authorization'] = window.localStorage.getItem('token');
axios.post( baseUrl + urlConfig.reservationZZsearch + '?personInfoId=' + this.personInfoId +'&isVip=2').then(response => {  //待预约

this.dyytableData = response.data;
if(response.data.length ==0){
fetch('post',urlConfig.reservationJCYYYData+this.personInfoId+'&scheduleBigClass=03').then(res => {  //已预约
this.yyytableData = res;
if(res.length ==0){
this.bigTabIndex == 0;
}else{
this.bigTabIndex == 1;
}
this.$store.commit('updateLoadingStatus',{isLoading:false});
}).catch(error => {

})
}else{
this.$store.commit('updateLoadingStatus',{isLoading:false});
}
}).catch(function (error) {
promptMessage('提示: ' +error);

});

}
this.contentHeight();
},
getopenid(code){
let cutton = 'http://front.wh.jinxin-fertility.com/pregnancyRegistration';
axios.get('http://front.wh.jinxin-fertility.com/weixin/getOpenIdByCode?code=' +  code+'&hosCode='+this.hosCode).then(response => {
if(response.data.resultCode == 'success'){
if(response.data.openid.trim() !=''){
this.openid = response.data.openid;

getken(this.getUserId);
}else{
let parmasquery = '?bb=1';
for(let i in this.$route.query){
if(i != 'code' && i != 'bb' ){
parmasquery = parmasquery +'&' + i + '=' + this.$route.query[i];

}
}
window.location.href = cutton+parmasquery+'&time='+((new Date()).getTime());
}
}else{
let parmasquery = '?bb=1';
for(let i in this.$route.query){
if(i != 'code' && i != 'bb' ){
parmasquery = parmasquery +'&' + i + '=' + this.$route.query[i];

}
}
window.location.href = cutton+parmasquery+'&time='+((new Date()).getTime());
}

}).catch(function (error) {
promptMessage('提示' +error)
this.submitdisabled = true;
this.$store.commit('updateLoadingStatus',{isLoading:true});

});
},
getUrlParam (name) {
var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
let url = location.href;
let search = url.split('?')[1]
if (search) {
var r = search.substr(0).match(reg)
if (r !== null) return decodeURI(r[2])
return null
} else {
return null
}
}
},
mounted(){
let _this = this;
this.hosCode =this.$route.query.hosCode;
if(!this.$route.query.hosCode){
this.hosCode ='420100000002';
}


this.pageTpe = this.$route.query.type;

if(!this.pageTpe){
this.pageTpe ='all';
this.headTitle = '全部已预约';
}
this.contentHeight();

if(this.$route.query.openid){
this.openid = this.$route.query.openid;
getken(this.getUserId);
}else{
this.$store.commit('updateLoadingStatus',{isLoading:true});
axios.get('http://front.wh.jinxin-fertility.com/weixin/getsigninfo?url=' + encodeURIComponent(window.location.href)
+'&hosCode=' + this.hosCode
).then(response => {
this.weixindata = response.data;
const code = _this.getUrlParam('code');
if(!_this.$route.query.code){
var appid = response.data.appId;
console.log(location.href)
var redirect_uri = encodeURIComponent(location.href);
if(code == null || code === ''){
window.location.href = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" + appid + "&redirect_uri=" + redirect_uri + "&response_type=code&scope=snsapi_base&state=1#wechat_redirect"
}
}else{
_this.getopenid(_this.$route.query.code)

}


wx.config({
debug: false,
timestamp: _this.weixindata.timestamp,
nonceStr: _this.weixindata.noncestr,
signature: _this.weixindata.signature,
appId: _this.weixindata.appId,
jsApiList: ['onMenuShareAppMessage','onMenuShareTimeline','hideMenuItems']
});
}).catch(function (error) {
promptMessage('提示' +error)

});
}
/*      if(this.pageTpe == 'ss'){  //手术
this.cancelReason();  
}*/

/*      if(this.$route.query.tabindex){
this.$nextTick(function(){
this.personInfoId = this.$route.query.personInfoId
this.bigTabIndex = 1;
this.gettableData();
});

}else{


}*/

/*      if(this.$route.query.pagenum == 'one'){
this.headTitle = '我的预约';

}else{
if(this.$route.query.tabindex){
this.$nextTick(function(){
this.personInfoId = this.$route.query.personInfoId
this.bigTabIndex = 1;
this.gettableData();
});

}else{
getken(this.getUserId);

}
}*/

}
}



// WEBPACK FOOTER //
// ./src/project/MyReservationProject/reservationIndex.vue